export default "__VITE_ASSET__136a92db__"